export default function placeDetails() {
  return {
    _id: false,
    type: 'droplet.placeDetails',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    ref: null,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/place-details/droplet.schema.js